import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StaticPageService } from '../../../shared/services/static-page.service';
import { CotizacionPayload } from '../../../shared/models/static-model/analisis.model';
import { LoadGeneralComponent } from '../../../shared/components-generals/load-general/load-general.component';
import { CommonModule } from '@angular/common';

export interface KeyConfig {
  key: string; // clave original
  isMoney?: boolean;
  isPercentage?: boolean;
  isHighlight?: boolean;
  order?: number;
  disguise?: boolean; // Ocultar
  replacementName?: string; // nombre alternativo a key
}

export interface KeyValueMeta {
  key: string;
  value: any;
  isMoney: boolean;
  isPercentage: boolean;
  isHighlight: boolean;
  disguise?: boolean; // Ocultar
  replacementName?: string; // nombre alternativo a key
  order?: number;
}

@Component({
  standalone: true,
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  imports: [LoadGeneralComponent, CommonModule, TranslateModule],
})
export class SummaryComponent {
  public load = false;
  public summary: CotizacionPayload | null = null;
  public cotizacion: KeyValueMeta[] = [];
  public deudor: KeyValueMeta[] = [];
  public piePagina: KeyValueMeta[] = [];
  public accesorios: KeyValueMeta[][] = [];
  public avales: KeyValueMeta[][] = [];
  public accesoriosIntegraDetalle: KeyValueMeta[][] = [];
  public tramites: KeyValueMeta[][] = [];
  @Input() quotationId = 0;

  constructor(private staticPageService: StaticPageService) {}

  ngOnInit(): void {
    this.getSummary();
  }

  public getSummary(): void {
    this.load = true;
    this.staticPageService.getResumenArrendamiento(this.quotationId).subscribe((ress) => {
      if (ress) {
        const avales = [
          {
            area: 'Centro',
            calleNum: 'Av. Reforma 123',
            ciudad: 'CDMX',
            civil: 'Soltero',
            colonia: 'Juárez',
            cp: '06600',
            estado: 'CDMX',
            nacionalidad: 'Mexicana',
            nombre: 'Juan Pérez',
            persona: 'Aval',
            rfc: 'PEPJ800101XXX',
            tel: '5512345678',
            tipo: 'Físico',
          },
          {
            area: 'Norte',
            calleNum: 'Calle 45 #78',
            ciudad: 'CDMX',
            civil: 'Casado',
            colonia: 'Del Valle',
            cp: '03100',
            estado: 'CDMX',
            nacionalidad: 'Mexicana',
            nombre: 'Ana Gómez',
            persona: 'Aval',
            rfc: 'GOMA900202XXX',
            tel: '5523456789',
            tipo: 'Físico',
          },
        ];

        const accesoriosIntegraDetalle = [
          { desAdicional: 'Kit de Llantas', precio: 5000 },
          { desAdicional: 'GPS', precio: 2500 },
        ];

        const accesorios = [
          { desAdicional: 'Cubre Asientos', precio: 1200 },
          { desAdicional: 'Alarma', precio: 800 },
        ];

        const tramites = [
          { desAdicional: 'Registro Vehicular', precio: 1500 },
          { desAdicional: 'Tenencia', precio: 800 },
        ];

        this.summary = ress;
        this.cotizacion = this.objectToKeyValueArray(ress.cotizacion, [
          { key: 'pago1', isMoney: true },
          { key: 'precio', isMoney: true },
          { key: 'auto', order: 1, isHighlight: true, replacementName: 'Automóvil' },
        ]);
        this.deudor = this.objectToKeyValueArray(ress.deudor, []);
        this.piePagina = this.objectToKeyValueArray(ress.piePagina, []);
        // Simulados
        accesorios.forEach((accesorio) => {
          const acc = this.objectToKeyValueArray(accesorio, []);
          this.accesorios.push(acc);
        });
        avales.forEach((aval) => {
          const acc = this.objectToKeyValueArray(aval, []);
          this.avales.push(acc);
        });
        accesoriosIntegraDetalle.forEach((accesorios) => {
          const acc = this.objectToKeyValueArray(accesorios, []);
          this.accesoriosIntegraDetalle.push(acc);
        });
        tramites.forEach((tramite) => {
          const acc = this.objectToKeyValueArray(tramite, []);
          this.tramites.push(acc);
        });
      }
      this.load = false;
    });
  }

  public objectToKeyValueArray(
    obj: Record<string, any>,
    configs: KeyConfig[] = [],
  ): KeyValueMeta[] {
    const map = new Map<string, KeyConfig>();
    configs.forEach((cfg) => {
      const keyLower = String(cfg.key).toLowerCase().trim();
      if (keyLower) map.set(keyLower, cfg);
    });

    const result: KeyValueMeta[] = Object.entries(obj).map(([rawKey, value]) => {
      const keyLower = String(rawKey).toLowerCase().trim();
      const cfg = map.get(keyLower);

      const displayKey = cfg?.replacementName ?? rawKey;

      return {
        key: displayKey,
        value,
        isMoney: !!cfg?.isMoney,
        isPercentage: !!cfg?.isPercentage,
        isHighlight: !!cfg?.isHighlight,
        replacementName: cfg?.replacementName,
        order: cfg?.order,
        disguise: cfg?.disguise,
      };
    });

    result.sort((a, b) => {
      const ao = a.order ?? Number.MAX_SAFE_INTEGER;
      const bo = b.order ?? Number.MAX_SAFE_INTEGER;
      return ao - bo;
    });

    return result;
  }
}
